export const volumes = [
  {
    number: 1,
    title: 'Craniofacial Growth Foundations',
    subtitle: 'Understand the Biological Framework Behind Dentofacial Development',
    intro:
      'Start by building a clear understanding of how craniofacial structures develop throughout childhood and adolescence.',
    topics: [
      'Craniofacial growth anatomy.',
      'Maxillary and mandibular developmental patterns.',
      'Sutural growth and bone remodeling concepts.',
      'Vertical, sagittal, and transverse growth relationships.',
      'Normal developmental variation.',
      'Illustrated growth maps and anatomical diagrams.',
    ],
    takeaway: 'A stronger conceptual foundation for interpreting craniofacial development.',
    note: '',
  },
  {
    number: 2,
    title: 'Skeletal Maturity Assessment Roadmap',
    subtitle: 'Learn How Growth Indicators Fit Into Clinical Evaluation',
    intro:
      'Chronological age and skeletal maturity are not interchangeable. This volume introduces the major concepts used to assess developmental stage and interpret growth-related findings.',
    topics: [
      'Skeletal maturation principles.',
      'Cervical vertebral maturation concepts.',
      'Hand-wrist maturation assessment fundamentals.',
      'Growth velocity and developmental variability.',
      'Limitations of maturity indicators.',
      'Educational assessment flowcharts.',
    ],
    takeaway: 'A structured understanding of skeletal maturity assessment and its clinical limitations.',
    note: '',
  },
  {
    number: 3,
    title: 'Maxillomandibular Relationship Blueprint',
    subtitle: 'Organize the Assessment of Developing Skeletal Discrepancies',
    intro:
      'Learn how sagittal, vertical, and transverse relationships contribute to the overall dentofacial picture.',
    topics: [
      'Skeletal Class I, II, and III relationship concepts.',
      'Maxillary deficiency and excess.',
      'Mandibular growth patterns.',
      'Vertical facial development.',
      'Transverse discrepancies and posterior crossbites.',
      'Visual diagnostic comparison charts.',
    ],
    takeaway: 'A clearer framework for recognizing and classifying developing skeletal relationships.',
    note: '',
  },
  {
    number: 4,
    title: 'Dentofacial Diagnostic Pathway',
    subtitle: 'Connect Clinical Findings Into a Structured Assessment',
    intro:
      'A useful clinical evaluation considers the complete patient, not an isolated measurement. This volume organizes the essential components of dentofacial assessment into a connected educational workflow.',
    topics: [
      'Medical and dental history considerations.',
      'Extraoral and intraoral examination.',
      'Facial proportion assessment.',
      'Occlusal relationship evaluation.',
      'Cephalometric interpretation fundamentals.',
      'Red flags and specialist referral considerations.',
    ],
    takeaway:
      'An organized approach to reviewing clinical findings and identifying areas requiring further assessment.',
    note: '',
  },
  {
    number: 5,
    title: 'Orthopedic Planning Blueprint',
    subtitle: 'Understand the Foundations of Growth-Related Treatment Planning',
    intro:
      'Explore how diagnostic findings, developmental stage, and treatment objectives influence orthopedic planning considerations.',
    topics: [
      'Treatment objectives and clinical priorities.',
      'Observation versus intervention considerations.',
      'Foundations of functional orthopedic appliances.',
      'Maxillary expansion principles.',
      'Growth modification concepts and limitations.',
      'Patient-specific factors influencing planning.',
    ],
    takeaway:
      'A structured educational framework for understanding orthopedic treatment considerations.',
    note: 'This volume explains clinical principles; it does not provide patient-specific treatment prescriptions.',
  },
  {
    number: 6,
    title: 'Clinical Follow-Up & Growth Monitoring Roadmap',
    subtitle: 'Learn How to Organize Longitudinal Growth Assessment',
    intro:
      'Growth-related evaluation is an ongoing process. This final volume focuses on documenting observations, comparing clinical findings, and understanding how developmental changes may influence reassessment.',
    topics: [
      'Longitudinal growth documentation.',
      'Follow-up assessment frameworks.',
      'Clinical record comparison.',
      'Monitoring developmental changes.',
      'Recognition of findings requiring reassessment.',
      'Illustrated educational case reviews.',
    ],
    takeaway: 'A repeatable documentation framework for studying dentofacial growth over time.',
    note: '',
  },
];
